import { Component } from 'react';

class IteamBooksMenuComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mainMenuSections: this.props.sectionsAndBooks
        };

        this.pointerDownHandlerForBookItem = this.pointerDownHandlerForBookItem.bind(this);
    }

    pointerDownHandlerForBookItem(sectionItem) {
        this.props.showBooksMenu();
        this.props.loadSectionHandler(sectionItem);
    }



    componentDidMount() {
        console.log('SECTIONS MENU CALLING DISABLE GAME INPUTS');
        this.props.disableGameInputsCallback();
    }

    componentWillUnmount(){
        console.log('SECTIONS MENU CALLING ENABLE GAME INPUTS');
        this.props.enableGameInputsCallback();
    }

    render() {
        let mainMenuSections = this.state.mainMenuSections;

        let itemList = mainMenuSections.map((item, index) => {
            let classNameOfItem = 'booksMenuItem';
            if (index === mainMenuSections.length - 1) {
                classNameOfItem += ' booksItemNoBottomBorder';
            }
            
            return (<div key={index} className={classNameOfItem} >
                        <button onClick={() => {this.pointerDownHandlerForBookItem(item);}}>
                            <span className='booksMenuBookName'>{item.title}</span>
                        </button>
                    </div>);
        });

        return (<div className='booksMenuContainer'>
                <div className='booksMenuContainerBlend'></div> 
                {itemList}
                </div>);
    }
}

export default IteamBooksMenuComponent;